<template>
  <div class="address">
    <a-cascader
      :options="options"
      @change="onChange"
      placeholder="请选择地址"
      :defaultValue="defaultAddress"
    >
      <a-icon
        type="home"
        slot="suffixIcon"
        class="test"
      />
    </a-cascader>
    <a-input
      placeholder="详细地址"
      :disabled="disabledinput"
      @change="changeAddress"
      :defaultValue="address"
      v-model="district"
    />
  </div>
</template>
<script>
import addressValue from "@/units/addressValue";
export default {
  name: "eAddress",
  props: { defaultAddress: Array },
  created() {
    this.options = addressValue;
    this.addressInfo = this.defaultAddress;
  },
  data() {
    return {
      options: null,
      addressInfo:{
        
      },
      address: "",
      district:'',
      disabledinput:true
    };
  },
  methods: {
    onChange(val) {
       if(val.length>0){
        this.disabledinput=false
      }else{
        this.disabledinput=true
        this.district=''
      }
      this.addressInfo = val;
      this.$emit("changeAddress", this.addressInfo);
    },
    changeAddress(data) {
      // console.log(this.addressInfo.address)
      this.addressInfo.address = data.target.value;
      this.$emit("changeAddress", this.addressInfo);
    },
  },
};
</script>
<style>
.ant-cascader-input.ant-input {
  position: relative;
  width: 230px;
  background-color: transparent !important;
  cursor: pointer;
}
</style>
<style lang="stylus">
.address {
  display: flex;

  input {
    width: 240px;
  }
}
</style>